import React from "react";
import { PostItem } from "./PostItem";
import * as prismicH from "@prismicio/helpers";
/**
 * Post list component
 */
export const PostList = ({ posts }) => {
  const [ogPosts, setOgPosts] = React.useState(posts);
  const [filteredPosts, setFilteredPosts] = React.useState(posts);
  const [searchText, setSearchText] = React.useState('')
  return (
    <div className="blog-main">
      <div style={{textAlign:'center', margin: 10, marginBottom: 30}}>
      <input id="searchInput"
       onChange={t => {
        const s = t.target.value
        if(!s?.length) {
          setFilteredPosts(ogPosts)
          return;
        }
        const text = s?.toLowerCase()?.replace('taskycal', 'vervo')?.replace('tasky', 'vervo')?.toLowerCase();
        console.warn(text)
        const p = ogPosts.filter(a=> JSON.stringify(a?.data?.title?.[0])?.toLowerCase().includes(text)
        || JSON.stringify(a?.data?.body?.[0])?.toLowerCase().includes(text)
        )

        setFilteredPosts(p)
       }}
      placeholder="Search..."
      style={{borderRadius: 4,
        width: 500,
        padding: 15,
        borderColor: `#29b9ff`,
        borderTopWidth: 1,
        boxShadow: `2px 2px 5px 0px #6666ff`
        }} />
      </div>
      
      {filteredPosts.map((post) => (
        <PostItem post={post} key={post.id} />
      ))}
    </div>
  );
};
